/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: program_team.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetProgramTeamRequest,
  GetProgramTeamResponse,
  ListProgramTeamsRequest,
  ListProgramTeamsResponse,
} from '../types/program_team';

export const createProgramTeamService = (transport: Transport) => ({
  async getProgramTeam(
    request: GetProgramTeamRequest,
    options: RequestOptions = {},
  ): Promise<GetProgramTeamResponse> {
    const { organization_id, program_id, team_id } = request;
    const url = getApiPath(API_METHODS.ProgramTeamService.GetProgramTeam, {
      organization_id,
      program_id,
      team_id,
    });
    return transport.get<GetProgramTeamResponse>(url, options);
  },

  async listProgramTeams(
    request: ListProgramTeamsRequest,
    options: RequestOptions = {},
  ): Promise<ListProgramTeamsResponse> {
    const { organization_id, program_id } = request;
    const url = getApiPath(API_METHODS.ProgramTeamService.ListProgramTeams, {
      organization_id,
      program_id,
    });
    return transport.get<ListProgramTeamsResponse>(url, options);
  },
});

export type ProgramTeamService = ReturnType<typeof createProgramTeamService>;
